import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormInput from '../../../../library/form/components/FormInput';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormCheckbox from '../../../../library/form/components/FormCheckbox';

const ListHeader = (props) => {
    const { formObject } = props;

    return (
        <div className='phViewArea' >
            <div className="uiCol">
                <ul className="uiHeaderTwoCol">
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docId" }} value="Catalog ID" />
                        </span>
                        <FormROValue formObject={formObject} rowKey="" action={{ paramName: "docId" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <SarasTrans value="Catalog Type" />
                        </span>
                        <FormROValue formObject={formObject} rowKey="" action={{ paramName: "listTypeSV" }} className="uiVal" />

                        <FormInput formObject={formObject} rowKey="" className="uiInput" 
                            action={{ InputType: "ac", paramName: "listType", acMethod: "ListDocuments" }}
                        />
                    </li>
                    <li>
                        <span style={{width:"125px"}} className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "showOnApp" }} value="Show On App" />
                        </span>
                        <div style={{width:"auto", display: 'inline-block'}} className="uiRow uiSpacer" >
                            <FormCheckbox formObject={formObject} rowKey='' action={{ actionId: "refresh", InputType: "onOff", paramName: "showOnApp" }} />
                        </div>
                    </li>
                    <li>
                        <span style={{width:"125px"}} className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "manualSelection" }} value="Is Manual Selection" />
                        </span>
                        <div style={{width:"auto", display: 'inline-block'}} className="uiRow uiSpacer" >
                            <FormCheckbox formObject={formObject} rowKey='' action={{ actionId: "refresh", refreshMode: "dep", InputType: "onOff", paramName: "manualSelection" }} />
                        </div>
                    </li>
                </ul>
            </div>
            <div className="uiCol">
                <ul className="uiHeaderTwoCol">
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "listName" }} value="Catalog Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" action={{ actionId: "refresh", InputType: "input", paramName: "listName" }} className="" />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "sortNo" }} value="Sort No" />
                        </span>
                        <div style={{width:"auto", display: 'inline-block'}} className="uiRow uiSpacer" >
                            <FormInput formObject={formObject} rowKey='' action={{ actionId: "refresh", InputType: "input", paramName: "sortNo" }} />
                        </div>
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "owner" }} value="Owner" />
                        </span>
                        <FormROValue formObject={formObject} rowKey="" action={{ paramName: "owner" }} className="uiVal" />
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default withView(ListHeader, "listHeader", "listChoiceCriteria,listChoice")